import React, { useEffect, useState } from "react";
import {
  Layout,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Space,
} from "antd";
import axiosInstance from "../api/axiosInstance";
import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";

const { Content } = Layout;
const { Option } = Select;

const ProjectsList = () => {
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]); // ✅ State untuk menyimpan daftar pengguna
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentProject, setCurrentProject] = useState(null);
  const [assignedUsers, setAssignedUsers] = useState([]); // ✅ State untuk menyimpan user yang dipilih

  useEffect(() => {
    fetchProjects();
    fetchUsers(); // ✅ Ambil daftar pengguna
  }, []);

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/referensi/project");
      setProjects(res.data);
    } catch (error) {
      message.error("Gagal mengambil data project");
    }
    setLoading(false);
  };

  const fetchUsers = async () => {
    try {
      const res = await axiosInstance.get("/referensi/user");
      setUsers(res.data);
    } catch (error) {
      message.error("Gagal mengambil data user");
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let projectId;

      if (currentProject) {
        await axiosInstance.put(
          `/referensi/project/${currentProject.id_project}`,
          values
        );
        projectId = currentProject.id_project;
        message.success("Project berhasil diperbarui");
      } else {
        const response = await axiosInstance.post("/referensi/project", values);
        projectId = response.data.id_project; // Ambil `id_project` dari response API
        message.success("Project berhasil ditambahkan");
      }

      // ✅ Jika ada user yang dipilih, simpan ke `td_assignment`
      if (assignedUsers.length > 0) {
        await axiosInstance.post("/assignment", {
          id_project: projectId,
          users: assignedUsers,
        });
        message.success("User berhasil di-assign ke project");
      }

      fetchProjects();
      setIsModalVisible(false);
      setCurrentProject(null);
      setAssignedUsers([]); // ✅ Reset state setelah submit
    } catch (error) {
      message.error("Gagal menyimpan project");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/referensi/project/${id}`);
      message.success("Project berhasil dihapus");
      fetchProjects();
    } catch (error) {
      message.error("Gagal menghapus project");
    }
  };

  const columns = [
    { title: "Nama Project", dataIndex: "nama_project", key: "nama_project" },
    { title: "Deskripsi", dataIndex: "deskripsi", key: "deskripsi" },
    {
      title: "Aksi",
      render: (text, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setCurrentProject(record);
              setIsModalVisible(true);
            }}
          >
            Edit
          </Button>
          <Button type="danger" onClick={() => handleDelete(record.id_project)}>
            Hapus
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ marginLeft: 260 }}>
        {/* Menyesuaikan lebar sidebar */}
        <AppHeader />
        <Content
          style={{
            margin: "20px",
            padding: "20px",
            background: "#fff",
            minHeight: "100vh",
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Daftar Projects</h2>
          <Button
            type="primary"
            onClick={() => {
              setCurrentProject(null);
              setIsModalVisible(true);
            }}
            style={{ marginBottom: "20px" }}
          >
            Tambah Project
          </Button>
          <Table
            columns={columns}
            dataSource={projects}
            loading={loading}
            rowKey="id_project"
            style={{ marginTop: "10px" }}
          />

          <Modal
            title={currentProject ? "Edit Project" : "Tambah Project"}
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
          >
            <Form
              initialValues={currentProject}
              onFinish={handleAddOrUpdate}
              layout="vertical"
            >
              <Form.Item
                label="Nama Project"
                name="nama_project"
                rules={[
                  { required: true, message: "Nama project wajib diisi!" },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Deskripsi" name="deskripsi">
                <Input.TextArea />
              </Form.Item>

              {/* ✅ Tambahkan Select untuk Assign User */}
              <Form.Item label="Assign Users" name="users">
                <Select
                  mode="multiple"
                  placeholder="Pilih user untuk project ini"
                  onChange={setAssignedUsers} // ✅ Simpan user yang dipilih ke state
                >
                  {users.map((user) => (
                    <Option key={user.id_user} value={user.id_user}>
                      {user.nama_user} ({user.jabatan_user})
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Button type="primary" htmlType="submit">
                Simpan
              </Button>
            </Form>
          </Modal>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ProjectsList;
